"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputEnvironmentVariableUndefinedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../common/localizeUtils");
const errorCode = "OutputEnvironmentVariableUndefined";
const messageKey = "error.driver.outputEnvironmentVariableUndefined"; // The output environment variable name(s) are not defined.
// This error should only be thrown when an internal logic calls the action directly. If users defines wrong output env vars in the yml file, the schema validation is expected to find the error and instruct users to fix them.
class OutputEnvironmentVariableUndefinedError extends teamsfx_api_1.SystemError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey),
        });
    }
}
exports.OutputEnvironmentVariableUndefinedError = OutputEnvironmentVariableUndefinedError;
//# sourceMappingURL=outputEnvironmentVariableUndefinedError.js.map